__turbopack_context__.v({
  "favoritesIcon": "o8Ju6a_favoritesIcon",
  "iconsWrapper": "o8Ju6a_iconsWrapper",
});
